import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import './swiper.min.css'
Vue.use(VueAwesomeSwiper)
